import type { Vec2 } from '../../../geo/types';
import committed from '../../../data/woodcutTrees.json';

function fail(message: string): never {
  throw new Error(`woodcutTrees.json: ${message}`);
}

/** The trees file, checked: the feet of the trees the 1544 woodcut draws on open ground (tools/woodcut). */
export function parseWoodcutTrees(value: unknown): readonly Vec2[] {
  const trees = (value as { trees?: unknown } | null)?.trees;
  if (!Array.isArray(trees)) fail('no trees');
  return trees.map((tree: unknown, i): Vec2 => {
    if (!Array.isArray(tree) || tree.length !== 2 || !tree.every(Number.isFinite))
      fail(`tree ${i} is not a place`);
    return [tree[0] as number, tree[1] as number];
  });
}

export const WOODCUT_TREES: readonly Vec2[] = parseWoodcutTrees(committed);
